<template>
  <div>
    <div class="marginCenter">
      <div class="marginBom30 marginTop30 navTitle flex-yCenter flex-sb">
        <div class="left flex">
          <div class="line"></div>
          <span>进修过程登记</span>
        </div>
      </div>
      <div class="query marginBom24">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="申请时间：">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="changeDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="form.trainType"
              clearable
              placeholder="请选择进修类型"
            >
              <el-option
                v-for="item in dict.type.train_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            style="width: 140px"
            class="fr blueBtn1"
            @click="search"
            >查询</el-button
          >
        </el-form>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ backgroundColor: '#f5f5f5' }"
      >
        <el-table-column
          prop="date"
          label="进修类型"
          align="center"
          width="109"
          ><span slot-scope="scope">{{
            dict.type.train_type.filter(
              (item) => item.value == scope.row.trainType
            )[0].label
          }}</span>
        </el-table-column>
        <el-table-column
          prop="applyTime"
          min-width="133"
          label="进修申请时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="date"
          width="109"
          label="轮转科室"
          align="center"
        >
          <template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              >
                {{ item.deptName }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          width="233"
          label="进修时间"
          align="center"
        >
          <template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              >
                {{ item.beginDate }}~{{ item.endDate }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="other"
          label="缺勤情况"
          align="center"
          width="109"
        >
          <template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              > 
                <div v-if="item.inConfirmFlag==1">
                  <el-button type="text" @click="$router.push({path:'/process/absenteeism',query:{trainObj:JSON.stringify(item),operationType:0,registrationType:1},})">查看</el-button>
                  <el-button v-if="item.outAppraisalFlag==0" type="text" @click="$router.push({path:'/process/absenteeism',query:{trainObj:JSON.stringify(item),operationType:1,registrationType:1},})">登记</el-button>
                </div>
                <span v-else>-</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="医疗问题"
          align="center"
          width="109"
          ><template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              >
                <div v-if="item.inConfirmFlag==1">
                  <el-button type="text" @click="$router.push({path:'/process/absenteeism',query:{trainObj:JSON.stringify(item),operationType:0,registrationType:2},})">查看</el-button>
                  <el-button v-if="item.outAppraisalFlag==0" type="text" @click="$router.push({path:'/process/absenteeism',query:{trainObj:JSON.stringify(item),operationType:1,registrationType:2},})">登记</el-button>
                </div>
                <span v-else>-</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="other"
          label="门/急诊平均每日人次"
          align="center"
          width="166"
          ><template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              >
              <div v-if="item.inConfirmFlag==1">
                <el-button type="text" @click="$router.push({path:'/process/absenteeism',query:{trainObj:JSON.stringify(item),operationType:0,registrationType:3},})">查看</el-button>
                <el-button v-if="item.outAppraisalFlag==0" type="text" @click="$router.push({path:'/process/absenteeism',query:{trainObj:JSON.stringify(item),operationType:1,registrationType:3},})">登记</el-button>
                </div>
                <span v-else>-</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="other"
          label="参加教学查房"
          align="center"
          width="109"
          ><template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              ><div v-if="item.inConfirmFlag==1">
                <el-button type="text" @click="$router.push({path:'/process/absenteeism',query:{trainObj:JSON.stringify(item),operationType:0,registrationType:4},})">查看</el-button>
                <el-button v-if="item.outAppraisalFlag==0" type="text" @click="$router.push({path:'/process/absenteeism',query:{trainObj:JSON.stringify(item),operationType:1,registrationType:4},})">登记</el-button>
                </div>
                <span v-else>-</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="other"
          label="参加诊断治疗技术"
          align="center"
          width="140"
          ><template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              >
              <div v-if="item.inConfirmFlag==1">
                <el-button type="text" @click="$router.push({path:'/process/diagnosis',query:{trainObj:JSON.stringify(item),operationType:0},})">查看</el-button>
                <el-button v-if="item.outAppraisalFlag==0" type="text" @click="$router.push({path:'/process/diagnosis',query:{trainObj:JSON.stringify(item),operationType:1},})">登记</el-button>
                </div>
                <span v-else>-</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="other"
          label="参加业务学习内容"
          align="center"
          width="140"
          ><template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              >
              <div v-if="item.inConfirmFlag==1">
                <el-button type="text" @click="$router.push({path:'/process/study',query:{trainObj:JSON.stringify(item),operationType:0},})">查看</el-button>
                <el-button v-if="item.outAppraisalFlag==0" type="text" @click="$router.push({path:'/process/study',query:{trainObj:JSON.stringify(item),operationType:1},})">登记</el-button>
                </div>
                <span v-else>-</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="other"
          label="参加手术操作情况"
          align="center"
          width="140"
          ><template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              ><div v-if="item.inConfirmFlag==1">
                <el-button type="text" @click="$router.push({path:'/process/operation',query:{trainObj:JSON.stringify(item),operationType:0,},})">查看</el-button>
                <el-button v-if="item.outAppraisalFlag==0" type="text" @click="$router.push({path:'/process/operation',query:{trainObj:JSON.stringify(item),operationType:1,},})">登记</el-button>
                </div>
                <span v-else>-</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="other"
          width="109"
          label="科室鉴定"
          align="center"
          ><template slot-scope="scope">
            <div class="myTable flex-column">
              <div
                class="myTable-td"
                v-for="(item, index) in scope.row.trainList"
                :key="index"
              >
                <div v-if="item.outAppraisalFlag==1">已鉴定</div>
                <span v-else>未鉴定</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { trainApplySelectApplyList } from "@/utils/api";
import { parseTime } from "@/utils/ruoyi";
export default {
  dicts: ["train_type"],
  components: {},
  data() {
    return {
      typeList: [],
      form: {
        date: [],
        params: {},
        registrationStatus: 1,
        archivesStatus:0
      },
      tableData: [],
      loading: false,
    };
  },
  created() {
    this.search();
    this.form.date=this.$route.query.date
  },
  methods: {
    // 日期切换
    changeDate(list) {
      if (list == undefined) {
        delete this.form.params.beginApplyTime;
        delete this.form.params.endApplyTime;
      } else {
        this.form.params.beginApplyTime = parseTime(list[0], "{y}-{m}-{d}");
        this.form.params.endApplyTime = parseTime(list[1], "{y}-{m}-{d}");
      }
    },
    // 获取列表数据
    search() {
      this.loading = true;
      trainApplySelectApplyList(this.form).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
        this.loading = false;
      });
    },
    link() {
      this.$router.push({
        path: "/leave/detail",
      });
    },
    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //   console.log(row,column,rowIndex,columnIndex);
    //   if (columnIndex === 0) {
    //     if (rowIndex % 2 === 0) {
    //       return {
    //         rowspan: 2,
    //         colspan: 1,
    //       };
    //     } else {
    //       return {
    //         rowspan: 0,
    //         colspan: 0,
    //       };
    //     }
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.query {
  padding: 20px;
  // height: 50px;
  background-color: #f5f5f5;
  .el-form-item {
    margin-bottom: 0;
  }
  .line {
    text-align: center;
  }
}
::v-deep .el-table .el-table__cell {
  padding: 0 !important;
}
::v-deep .el-table .cell {
  padding: 0 !important;
  line-height: 50px !important;
}
.myTable {
  justify-content: space-around;
  & > .myTable-td:not(:last-child) {
    border-bottom: 1px solid #ebeef5;
  }
  & > .myTable-td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.col {
  // display: inline-block;
  display: flex;
  justify-content: space-evenly;
  color: #1890ff;
  cursor: pointer;
  a {
    color: #1890ff;
  }
}
</style>
